import { formatDate } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { Validators } from '@angular/forms';
import {
  DIALOG_DATA,
  formatDateTimeStamp,
  getFormattedDate,
  getFormattedDateTime,
  getFormattedTime,
  getStartAndEndTime,
  MAX_SHIFT_DURATION,
} from '../../../../global.variable';
import { ToasterService } from '../../services/toaster.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
@Component({
  selector: 'gtapp-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrl: './scheduler.component.scss',
  standalone: false,
})
export class SchedulerComponent implements OnInit {
  repeatInterval: any;
  selectedMonthType: any;

  selectedRepeatType: any;

  errorMessage: string = '';
  validStartDate = getFormattedDate();
  validateEndDate = getFormattedDate();
  validStartDateTime = getFormattedDateTime();
  validEndDateMax = getFormattedDate(
    new Date().getTime() + 1000 * 60 * 60 * 24 * 45,
  );

  startDateTime: any;
  endDateTime: any;
  endDateTimeMax: any;

  schedulerFields = {
    startDateTime: { showInput: false, header: 'Start Date & Time' },
    endDateTime: { showInput: false, header: 'End Date & Time' },
    startDay: { showInput: false, header: 'Starts On' },
    startTime: { showInput: false, header: 'Start Time' },
    endDay: { showInput: false, header: 'Repeat Until' },
    endTime: { showInput: false, header: 'End Time' },
  };

  constructor(
    @Optional() protected dialogRef: DialogRef,
    private ngZone: NgZone,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
  ) {}

  @Input() schedulerForm: any;
  @Input() dialogBox: boolean = true;
  @Input() editSchedule: any;
  @Input() shownFrom: string = 'job';

  @Output() emitData = new EventEmitter();
  showRecurringView: boolean = false;

  repeatTypes = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
  ];
  frequencyDetails = [
    {
      value: 1,
      name: 'first',
    },
    {
      value: 2,
      name: 'second',
    },
    {
      value: 3,
      name: 'third',
    },
    {
      value: 4,
      name: 'fourth',
    },
    {
      value: -1,
      name: 'last',
    },
  ];
  selectedDays: any = [];
  availabledays = Array.from({ length: 28 }, (_, i) => i + 1);

  ngOnInit(): void {
    if (this.dialogueData) {
      this.schedulerForm = this.dialogueData?.schedulerForm;
      this.dialogBox = this.dialogueData?.dialogBox || true;

      this.editSchedule = this.dialogueData?.editSchedule;
    }

    if (this.editSchedule == true) {
      this.loadExistingData();
    } else {
      this.loadSessionData();
    }
  }
  getMinTimeValue() {
    if (
      this.schedulerForm.value.start_day === this.schedulerForm.value.end_day
    ) {
      return this.schedulerForm.value.start_time;
    }
    return null;
  }
  validateEndDay() {
    const startDate = this.schedulerForm.value.start_day
      ? new Date(this.schedulerForm.value.start_day)
      : new Date();

    let startDay = startDate;
    this.schedulerForm.controls['start_day'].setValue(
      getFormattedDate(startDate),
    );
    const selectedDate = new Date(startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time for accurate comparison

    // Check if the selected date is before today, then mark invalid
    if (selectedDate < today) {
      this.schedulerForm.controls['start_day'].setErrors({
        invalidStartDate: true,
      });
    } else {
      this.schedulerForm.controls['start_day'].setErrors(null); // Clear errors if valid
    }
    startDay.setDate(startDay.getDate() + 1);
    this.validateEndDate = getFormattedDate(startDay);

    this.validEndDateMax = getFormattedDate(
      startDay.getTime() + 1000 * 60 * 60 * 24 * 45,
    );
    let endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 14);
    this.schedulerForm.controls['end_day'].setValue(getFormattedDate(endDate));
  }
  validateEndTime() {
    this.changeEndDate();
    const endDay = new Date(this.schedulerForm.value?.end_day);
    if (endDay.getTime() > new Date(this.validEndDateMax).getTime()) {
      const startDay = new Date(this.schedulerForm.value?.start_day);
      this.schedulerForm.controls['end_day'].setValue(
        getFormattedDate(startDay.getTime() + 1000 * 60 * 60 * 24 * 45),
      );
      return;
    }
  }
  changeStartDateTime(event: any) {
    this.schedulerForm.controls['start_day'].setValue(
      getFormattedDate(event.target.value),
    );
    const selectedDate = new Date(event.target.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time for accurate comparison

    // Check if the selected date is before today, then mark invalid
    if (selectedDate < today) {
      this.schedulerForm.controls['start_day'].setErrors({
        invalidStartDate: true,
      });
    } else {
      this.schedulerForm.controls['start_day'].setErrors(null); // Clear errors if valid
    }

    this.schedulerForm.controls['start_time'].setValue(
      getFormattedTime(event.target.value),
    );

    this.changeEndDate();
  }
  changeEndDateTime(event: any) {
    this.errorMessage = '';
    let startDateTime = new Date(this.startDateTime);
    let endDateTime = new Date(this.endDateTime);
    if (event.target.value) {
      endDateTime = new Date(this.endDateTime);
    } else {
      [startDateTime, endDateTime] = getStartAndEndTime(
        this.startDateTime ? new Date(this.startDateTime) : new Date(),
      );
    }

    if (endDateTime.getTime() > new Date(this.endDateTimeMax).getTime()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Shift Time Exceeded.',
      });
      this.errorMessage = 'Shift Time Exceeded.';
      this.schedulerForm.controls['end_day'].setValue(null);
      return;
    }

    // If end date/time is earlier than start date/time, clear it or handle as needed
    if (endDateTime < startDateTime) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'End time must be greater than start time.',
      });
      this.errorMessage = 'End time must be greater than start time.';
      this.schedulerForm.controls['end_day'].setValue(null);
    } else {
      this.schedulerForm.controls['end_day'].setValue(
        getFormattedDate(endDateTime),
      );

      this.schedulerForm.controls['end_time'].setValue(
        getFormattedTime(endDateTime),
      );
      this.endDateTime = getFormattedDateTime(
        this.schedulerForm.value.end_day +
          ' ' +
          this.schedulerForm.value.end_time,
      );
    }
  }
  changeEndDate() {
    const [startDateTime, endDateTime] = getStartAndEndTime(new Date());
    if (!this.schedulerForm.value.start_time) {
      this.schedulerForm.controls['start_time'].setValue(
        getFormattedTime(startDateTime),
      );
    }
    if (!this.schedulerForm.value.end_time) {
      this.schedulerForm.controls['end_time'].setValue(
        getFormattedTime(endDateTime),
      );
    }
    if (!this.schedulerForm.value.end_day) {
      this.schedulerForm.controls['end_day'].setValue(
        getFormattedDate(endDateTime),
      );
    }
    if (
      this.schedulerForm.value.start_day == this.schedulerForm.value.end_day &&
      this.schedulerForm.value.repeat_type != 'once'
    ) {
      //app.shortcut.com/sendem/story/10405/bug-while-creating-shifts-with-repeat-type-daily-and-end-date-on-the-same-day
      https: this.schedulerForm.controls['repeat_type'].setValue('once');
      this.showRecurringView = false;
    }
    const scheduleStartDateTime = new Date(
      this.schedulerForm.value.start_day +
        ' ' +
        this.schedulerForm.value.start_time,
    );
    const scheduleEndDateTime = new Date(
      this.schedulerForm.value.end_day +
        ' ' +
        this.schedulerForm.value.end_time,
    );

    if (scheduleStartDateTime.getTime() > scheduleEndDateTime.getTime()) {
      let tomorrow = new Date(scheduleStartDateTime);
      tomorrow.setHours(
        scheduleStartDateTime.getHours() + 8,
        scheduleStartDateTime.getMinutes(),
        0,
        0,
      );
      if (
        this.showRecurringView &&
        new Date().getDate() <= tomorrow.getDate()
      ) {
        tomorrow.setDate(tomorrow.getDate() + 1);
      }

      this.validateEndDate = getFormattedDate(tomorrow);

      this.schedulerForm.controls['end_day'].setValue(this.validateEndDate);
      this.schedulerForm.controls['end_time'].setValue(
        getFormattedTime(tomorrow),
      );
    } else {
      this.validateEndDate = getFormattedDate(
        this.schedulerForm.value.start_day,
      );
    }
    this.formatStartEndDateTime();
  }
  loadExistingData() {
    this.selectedRepeatType = this.schedulerForm.value.repeat_type;
    this.showRecurringView = this.selectedRepeatType === 'once' ? false : true;

    if (!this.schedulerForm.value.start_time) {
      this.schedulerForm.controls['start_time'].setValue(getFormattedTime());
    }

    if (!this.schedulerForm.value.end_time) {
      let endDateTime = new Date().setHours(new Date().getHours() + 1);
      this.schedulerForm.controls['end_time'].setValue(
        getFormattedTime(endDateTime),
      );
    }

    this.repeatInterval = this.schedulerForm.value.repeat_interval;
    if (this.selectedRepeatType === 'weekly') {
      this.selectedDays = this.schedulerForm.value.repeat_details;
    }
    if (this.selectedRepeatType === 'monthly') {
      this.selectedMonthType =
        this.schedulerForm.value?.month_repeat_case || 'day';
      if (this.schedulerForm.value.repeat_details) {
        if (
          Array.isArray(this.schedulerForm.value.repeat_details) &&
          this.selectedMonthType == 'day'
        ) {
          this.selectedDays = this.schedulerForm.value.repeat_details || [];
        }
      }
    }

    const scheduleStartTime = new Date(
      this.schedulerForm.value.start_day +
        ' ' +
        this.schedulerForm.value.start_time,
    );
    const scheduleStartDay = new Date(scheduleStartTime);
    scheduleStartTime.setHours(0, 0, 0, 0);

    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    if (scheduleStartDay.getTime() < todayDate.getTime()) {
      this.validStartDate = getFormattedDate();
      let tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 1);
      this.schedulerForm.controls['start_day'].setValue(
        getFormattedDate(tomorrow),
      );
    }
    this.changeEndDate();
  }

  formatDateWithoutTime = (date: any) => {
    date.setHours(0, 0, 0, 0);
    return date.getTime();
  };
  formatStartEndDateTime() {
    const startDateTime = new Date(
      this.schedulerForm.value.start_day +
        ' ' +
        this.schedulerForm.value.start_time,
    );
    this.startDateTime = getFormattedDateTime(startDateTime);

    this.endDateTimeMax = getFormattedDateTime(
      new Date(startDateTime.getTime() + 1000 * 60 * 60 * MAX_SHIFT_DURATION),
    );
    this.endDateTime = getFormattedDateTime(
      this.schedulerForm.value.end_day +
        ' ' +
        this.schedulerForm.value.end_time,
    );

    if (
      new Date(this.endDateTimeMax).getTime() <
        new Date(this.endDateTime).getTime() &&
      !this.showRecurringView
    ) {
      this.schedulerForm.controls['end_day'].setValue(
        getFormattedDate(this.endDateTimeMax),
      );

      this.schedulerForm.controls['end_time'].setValue(
        getFormattedTime(this.endDateTimeMax),
      );
      this.endDateTime = getFormattedDateTime(
        this.schedulerForm.value.end_day +
          ' ' +
          this.schedulerForm.value.end_time,
      );
    }
  }

  loadNewData() {
    this.selectedRepeatType = 'once';
    // format start and end day on initial data
    this.schedulerForm.controls['start_day'].setValue(getFormattedDate());
    this.schedulerForm.controls['end_day'].setValue(getFormattedDate());
    this.schedulerForm.controls['start_time'].setValue(getFormattedTime());
    let endDateTime = new Date().setHours(new Date().getHours() + 1);
    this.schedulerForm.controls['end_time'].setValue(
      getFormattedTime(endDateTime),
    );

    this.saveSessionData();
    this.formatStartEndDateTime();
  }

  onCloseDialogue() {
    if (this.dialogBox) {
      this.dialogRef.close(false);
    } else {
      this.emitData.emit(false);
    }
  }
  changeMonthType(type: any) {
    if (type === this.selectedMonthType) return;
    this.schedulerForm.controls['month_repeat_case'].setValue(type);

    this.selectedMonthType = type;

    if (type == 'day') {
      this.schedulerForm.controls['position'].setValue(null);
      this.schedulerForm.controls['week_day'].setValue(null);
      this.schedulerForm.controls['repeat_details'].setValue([]);
    } else {
      this.selectedDays = null;
      this.schedulerForm.controls['position'].enable();
      this.schedulerForm.controls['week_day'].enable();
      this.schedulerForm.controls['repeat_details'].setValue([]);
    }
  }
  makeRecuringView() {
    this.showRecurringView = true;
    this.selectedRepeatType = 'daily';

    const startDate = new Date(this.schedulerForm.value.start_day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (startDate < today) {
      this.schedulerForm.controls['start_day'].setValue(getFormattedDate());
    }

    let endDate = new Date(this.schedulerForm.value.start_day);
    endDate.setDate(endDate.getDate() + 14);

    this.schedulerForm.controls['end_day'].setValue(getFormattedDate(endDate));
    this.schedulerForm.controls['repeat_type'].setValue(
      this.selectedRepeatType,
    );
    let startDay = new Date(this.schedulerForm.value.start_day);
    startDay.setDate(startDay.getDate() + 1);
    this.validateEndDate = getFormattedDate(startDay);
    this.formatStartEndDateTime();
    this.saveSessionData();
  }
  cancelRecuringView() {
    this.ngZone.run(() => {
      setTimeout(() => {
        this.schedulerForm.controls['repeat_details'].removeValidators(
          Validators.required,
        );

        this.schedulerForm.controls['repeat_details'].updateValueAndValidity();
      });
    });
    this.showRecurringView = false;
    this.selectedRepeatType = 'once';
    this.schedulerForm.controls['repeat_type'].setValue(
      this.selectedRepeatType,
    );
    this.schedulerForm.controls['end_day'].setValue(
      getFormattedDate(new Date(this.schedulerForm.value.start_day)),
    );
    this.saveSessionData();
    this.formatStartEndDateTime();
  }

  updateRepeatDetails() {
    if (
      this.schedulerForm.value?.position &&
      this.schedulerForm.value?.week_day
    ) {
      let repeatDetails = this.schedulerForm.value?.repeat_details || [];
      repeatDetails.push({
        position: this.schedulerForm.value?.position,
        week_day: this.schedulerForm.value?.week_day,
      });
      this.schedulerForm.controls['repeat_details'].setValue(repeatDetails);
    }
  }
  selectWeekDays(day: any) {
    this.selectedDays = [...(this.selectedDays || [])];

    if (this.selectedDays?.includes(day)) {
      const index = this.selectedDays.indexOf(day, 0);
      if (index > -1) {
        this.selectedDays.splice(index, 1);
      }
    } else {
      this.selectedDays.push(day);
    }

    this.schedulerForm.controls['repeat_details'].setValue(this.selectedDays);
  }

  submitSchedule() {
    this.schedulerForm.value.start_day =
      this.schedulerForm.value.start_day == ''
        ? ''
        : formatDate(this.schedulerForm.value.start_day, 'yyyy-MM-dd', 'en');
    this.schedulerForm.value.end_day =
      this.schedulerForm.value.end_day == null
        ? null
        : formatDate(this.schedulerForm.value.end_day, 'yyyy-MM-dd', 'en');
    let timezoneOffset = new Date();

    let data = {
      time_offset: timezoneOffset.getTimezoneOffset(),
      ...this.schedulerForm.value,
    };
    if (this.dialogBox) {
      this.dialogRef.close(data);
    } else {
      this.emitData.emit(data);
    }
    this.saveSessionData();
  }
  shiftClick(elementID: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementID);
      element?.click();
      element?.focus();
    }, 100);
  }

  onRepeatTypeChange(event: any) {
    this.ngZone.run(() => {
      setTimeout(() => {
        this.selectedRepeatType = event;
        this.saveSessionData();
        this.selectedDays = [];
        this.schedulerForm.controls['repeat_details'].setValue([]);
        this.schedulerForm.controls['repeat_details'].removeValidators(
          Validators.required,
        );
        if (['monthly', 'weekly'].includes(event)) {
          this.schedulerForm.controls['repeat_details'].setValidators(
            Validators.required,
          );
        }
        this.schedulerForm.controls['repeat_details'].updateValueAndValidity();
      }, 100);
    });
  }

  loadSessionData() {
    let schedulerData = JSON.parse(
      sessionStorage.getItem('schedulerData') || '{}',
    );

    if (Object.keys(schedulerData?.schdeuleData || {})?.length) {
      if (schedulerData?.schdeuleData?.formData) {
        this.schedulerForm.patchValue(schedulerData?.schdeuleData?.formData);
      }
      if (schedulerData?.schdeuleData?.selectedRepeatType) {
        this.selectedRepeatType =
          schedulerData?.schdeuleData?.selectedRepeatType;
        this.repeatInterval = schedulerData?.schdeuleData?.repeatInterval;
        this.selectedMonthType = schedulerData?.schdeuleData?.selectedMonthType;
        this.showRecurringView =
          this.selectedRepeatType == 'once' ? false : true;
      }
      this.formatStartEndDateTime();
    } else {
      this.loadNewData();
    }
  }

  saveSessionData() {
    if (!this.editSchedule)
      sessionStorage.setItem(
        'schedulerData',
        JSON.stringify({
          schdeuleData: {
            formData: this.schedulerForm.value,
            selectedRepeatType: this.selectedRepeatType,
            repeatInterval: this.repeatInterval,
            selectedMonthType: this.selectedMonthType,
          },
        }),
      );
  }
  focusField(
    field:
      | 'startDateTime'
      | 'endDateTime'
      | 'startDay'
      | 'startTime'
      | 'endDay'
      | 'endTime',
  ) {
    this.schedulerFields[field].showInput = true;
    switch (field) {
      case 'startDateTime':
        this.shiftClick('startDay');
        break;
      case 'endDateTime':
        this.shiftClick('endDay');
        break;
      case 'startDay':
        this.shiftClick('startDay');
        break;
      case 'startTime':
        this.shiftClick('startTime');
        break;
      case 'endTime':
        this.shiftClick('endTime');
        break;
      case 'endDay':
        this.shiftClick('endDay');
        break;
    }
  }
}
